export default __webpack_public_path__ + "static/media/5.ab7cbb34.jpg";